import { AxiosError } from 'axios'
import { ENDPOINT_WORKSPACE_MEMBERS } from '../config'
import AuthAxios from '@/lib/api/axios/AuthAxios'

export interface UpdateMemberRoleRequest {
  role: string
}

export interface UpdateMemberRoleResponse {
  message: string
}

/**
 * Update a member's role in the workspace
 * PATCH /api/v1/e/{workspaceSlug}/members/{memberId}/role
 */
const updateMemberRole = async (
  workspaceSlug: string,
  memberId: string,
  request: UpdateMemberRoleRequest,
): Promise<UpdateMemberRoleResponse> => {
  try {
    const response = await AuthAxios.patch<UpdateMemberRoleResponse>(
      `${ENDPOINT_WORKSPACE_MEMBERS}/${workspaceSlug}/members/${memberId}/role`,
      request
    )
    return response.data
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 403) {
      throw new Error('You do not have permission to change member roles')
    }
    throw error
  }
}

export default updateMemberRole
